import styled from '@emotion/styled';
import { Modal } from 'antd';

export const StyledModal = styled(Modal)`
  .ant-modal-title {
    font-weight: 600;
  }
`;
